import { Box, Container, Typography, Chip, Button } from "@mui/material";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DirectionsIcon from "@mui/icons-material/Directions";
import StarIcon from "@mui/icons-material/Star";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import locationBg from "../../assets/images/contact_location_bg.png";
import infoCardBg from "../../assets/images/contact_info_card_bg.png";
import cardBg from "../../assets/images/contact_small_card_bg.png";
import locationBgm from "../../assets/images/contact_location_bg_m.png";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const serviceAreas = ["Ajax", "Pickering", "Whitby"];

const contactItems = [
  {
    title: "Service Location",
    value: "15 Westney Rd N, Unit 4A, Ajax, ON L1T 1P5",
    icon: <LocationOnIcon />,
    action: "Get Directions",
    link: "https://maps.app.goo.gl/9MGK7egcJR38kYFk6",
  },

  {
    title: "Phone",
    value: "Call For Assistance",
    icon: <PhoneIcon />,
    action: "Call Now",
    link: "tel:+19054283542",
  },

  {
    title: "Email",
    value: "cometcleaners5@gmail.com",
    icon: <EmailIcon />,
    action: "Send Email",
    link: "mailto:cometcleaners5@gmail.com",
  },

  {
    title: "Service Areas",
    value: "Ajax • Pickering • Whitby • Surrounding Areas",
    icon: <LocalShippingIcon />,
    action: "Pickup & Delivery",
    link: "#",
  },
];

export default function ContactLocation() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        position: "relative",

        overflow: "hidden",

        backgroundImage: {
          xs: `url(${locationBgm}) `,
          md: `url(${locationBg}) `,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",
      }}
    >
      <Container maxWidth="xl">
        {/* Heading */}

        <Box
          sx={{
            textAlign: "center",

            mb: {
              xs: 5,
              md: 8,
            },
          }}
        >
          <Box
            sx={{
              display: "inline-flex",

              px: 2.5,

              py: 1,

              borderRadius: "50px",

              background: "rgba(0,87,255,.08)",

              color: "#0057FF",

              fontSize: "12px",

              fontWeight: 800,

              letterSpacing: "1px",

              textTransform: "uppercase",
            }}
          >
            Visit Us
          </Box>

          <Typography
            sx={{
              mt: 2,

              fontWeight: 900,

              lineHeight: 1.05,

              color: "#07122F",

              fontSize: {
                xs: "32px",
                sm: "32px",
                md: "56px",
                lg: "56px",
              },
            }}
          >
            Serving Communities
            <br />
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Across Durham Region
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 2,

              maxWidth: "700px",

              mx: "auto",

              color: "#64748B",

              lineHeight: 1.8,
              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
              },
            }}
          >
            Professional laundry, dry cleaning and garment care services with
            convenient pickup and delivery.
          </Typography>
        </Box>

        {/* Content */}

        <Box
          sx={{
            display: "flex",

            flexDirection: {
              xs: "column",
              lg: "row",
            },

            gap: {
              xs: 3,
              md: 4,
            },
          }}
        >
          {/* LEFT MAP */}

          <Box
            sx={{
              flex: 1,

              position: "relative",

              minHeight: {
                xs: 240,
                sm: 300,
                md: 550,
              },

              borderRadius: {
                xs: "24px",
                md: "34px",
              },

              overflow: "hidden",

              border: "1px solid rgba(255,255,255,.9)",

              boxShadow: "0 30px 80px rgba(0,87,255,.10)",

              background: "#fff",
            }}
          >
            <iframe
              title="Comet Cleaners Location"
              width="100%"
              height="100%"
              style={{
                border: 0,
              }}
              loading="lazy"
              allowFullScreen
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2876.8371240111555!2d-79.0426300239862!3d43.859204471093086!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4dfecc0aa0f87%3A0x6b538efd0494f78b!2sComet%20Cleaners!5e0!3m2!1sen!2sin!4v1781097102897!5m2!1sen!2sin&output=embed"
            />

            {/* MAP CARD */}

            {/* <Box
              sx={{
                position: "absolute",

                top: {
                  xs: 12,
                  md: 24,
                },

                left: {
                  xs: 12,
                  md: 24,
                },

                p: {
                  xs: 1.5,
                  md: 2.5,
                },

                borderRadius: {
                  xs: "18px",
                  md: "24px",
                },

                background: "rgba(255,255,255,.95)",

                backdropFilter: "blur(18px)",

                boxShadow: "0 20px 50px rgba(0,87,255,.12)",

                width: {
                  xs: "220px",
                  sm: "260px",
                  md: "320px",
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 900,

                  color: "#07122F",

                  fontSize: "16px",
                }}
              >
                Comet Cleaners
              </Typography>

              <Typography
                sx={{
                  color: "#64748B",
                  fontSize: "14px",
                  mt: 0.5,
                }}
              >
                15 Westney Rd N, Unit 4A, Ajax, ON L1T 1P5
              </Typography>

              <Box
                sx={{
                  display: "flex",

                  alignItems: "center",

                  gap: 0.5,

                  mt: 1.5,
                }}
              >
                <StarIcon
                  sx={{
                    color: "#FFB800",
                    fontSize: "14px",
                  }}
                />

                <Typography
                  sx={{
                    fontWeight: 800,
                    fontSize: "14px",
                  }}
                >
                  4.9
                </Typography>

                <Typography
                  sx={{
                    color: "#64748B",
                    fontSize: "14px",
                  }}
                >
                  (128 Reviews)
                </Typography>
              </Box>

              <Button
                startIcon={<DirectionsIcon />}
                sx={{
                  mt: 1.5,

                  minHeight: {
                    xs: 34,
                    md: 46,
                  },

                  px: {
                    xs: 1.5,
                    md: 2.5,
                  },

                  fontSize: {
                    xs: "11px",
                    md: "15px",
                  },

                  borderRadius: "50px",

                  textTransform: "none",

                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  color: "#fff",

                  fontWeight: 700,
                }}
              >
                Get Directions
              </Button>
            </Box> */}
          </Box>

          {/* RIGHT SIDE */}

          <Box
            sx={{
              flex: 1,
            }}
          >
            <Box
              sx={{
                p: {
                  xs: 2.5,
                  md: 4,
                },

                height: "100%",

                borderRadius: "34px",

                position: "relative",

                overflow: "hidden",

                backgroundImage: `
        url(${infoCardBg})
      `,

                backgroundSize: "cover",

                backgroundPosition: "center",

                border: "1px solid rgba(255,255,255,.9)",

                boxShadow: "0 25px 70px rgba(0,87,255,.08)",
              }}
            >
              {/* HEADER */}

              <Box
                sx={{
                  display: "flex",

                  justifyContent: "space-between",

                  alignItems: "center",

                  mb: 4,
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontWeight: 900,

                      color: "#07122F",

                      fontSize: {
                        xs: "16px",
                        sm: "16x",
                        md: "22px",
                        lg: "22px",
                      },
                    }}
                  >
                    Visit Our Location
                  </Typography>

                  <Box
                    sx={{
                      width: 70,

                      height: 4,

                      mt: 1,

                      borderRadius: "20px",

                      background: "linear-gradient(90deg,#0057FF,#1DB6FF)",
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    display: {
                      xs: "none",
                      md: "flex",
                    },

                    width: 95,

                    height: 75,

                    borderRadius: "22px",

                    flexDirection: "column",

                    justifyContent: "center",

                    alignItems: "center",

                    background: "linear-gradient(135deg,#ffffff,#f3f8ff)",

                    border: "1px solid rgba(0,87,255,.08)",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 900,

                      color: "#0057FF",

                      fontSize: {
                        xs: "16px",
                        sm: "16x",
                        md: "22px",
                        lg: "22px",
                      },
                    }}
                  >
                    1000+
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: {
                        xs: "8px",
                        sm: "8x",
                        md: "10px",
                        lg: "10px",
                      },
                      textAlign: "center",

                      color: "#64748B",
                    }}
                  >
                    Happy Customers
                  </Typography>
                </Box>
              </Box>

              {/* CONTACT ITEMS */}

              <Box
                sx={{
                  display: "flex",

                  flexDirection: "column",

                  gap: 2,
                }}
              >
                {contactItems.map((item, index) => (
                  <Box
                    component="a"
                    href={item.link}
                    key={index}
                    sx={{
                      textDecoration: "none",

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "space-between",

                      p: 2,

                      borderRadius: "24px",

                      backgroundImage: `
            
              url(${cardBg})
            `,

                      backgroundSize: "cover",

                      backgroundPosition: "center",

                      border: "1px solid rgba(0,87,255,.08)",

                      transition: ".35s",

                      "&:hover": {
                        transform: "translateX(8px)",

                        boxShadow: "0 15px 40px rgba(0,87,255,.12)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",

                        alignItems: "center",

                        gap: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: 54,

                          height: 54,

                          borderRadius: "18px",

                          display: "flex",

                          alignItems: "center",

                          justifyContent: "center",

                          color: "#fff",

                          background: "linear-gradient(135deg,#0057FF,#1DB6FF)",
                        }}
                      >
                        {item.icon}
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 800,

                            color: "#07122F",
                          }}
                        >
                          {item.title}
                        </Typography>

                        <Typography
                          sx={{
                            color: "#64748B",
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Box>
                    </Box>

                    <Button
                      endIcon={<ChevronRightIcon />}
                      sx={{
                        borderRadius: "50px",

                        px: 2,

                        textTransform: "none",

                        fontWeight: 700,

                        color: "#0057FF",

                        background: "rgba(0,87,255,.08)",

                        display: {
                          xs: "none",
                          md: "flex",
                        },
                      }}
                    >
                      {item.action}
                    </Button>
                  </Box>
                ))}
              </Box>

              {/* SERVICE AREAS */}

              <Typography
                sx={{
                  mt: 4,

                  mb: 2,

                  fontWeight: 800,

                  color: "#07122F",
                }}
              >
                Service Areas
              </Typography>

              <Box
                sx={{
                  display: "flex",

                  flexWrap: "wrap",

                  gap: 1,
                }}
              >
                {serviceAreas.map((area) => (
                  <Chip
                    key={area}
                    icon={<LocationOnIcon />}
                    label={area}
                    clickable
                    sx={{
                      borderRadius: "50px",

                      fontWeight: 700,

                      background: "rgba(255,255,255,.9)",

                      border: "1px solid rgba(0,87,255,.12)",

                      "&:hover": {
                        background: "rgba(0,87,255,.08)",
                      },
                    }}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
